<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Bonafide Certificate </strong>
        </v-toolbar-title>
      </v-toolbar>

      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
            hint="Please Select Standard" />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data && div">
          <v-btn class="mt-6 button" @click="getbonafiedcertificates()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
      <v-row> </v-row>
    </v-card>
    <template>
      <v-card class="box no-display" v-if="data_list != ''">
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data_list" class="elevation-1 mytable no-display" dense
          :search="search">
          <template v-slot:item.issued="{ item }">
            <span v-if="item.issued">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:item.get="{ item }">
            <v-btn class="pt-1 pb-1" rounded color="info" v-if="item.issued" small :loading="show_cert_loader"
              @click="showCert(item)">Get Bonafide</v-btn>
            <!-- <v-btn class="pt-1 pb-1" rounded color="info"
              v-if="item.issued && tenant !== 'vvp' && tenant !== 'sanjivani' && tenant !== 'wws'" small
              :loading="show_cert_loader" @click="showCert1(item)">Get Bonafide (Print)</v-btn> -->
            <!-- <v-btn class="pt-1 pb-1 ml-1" rounded color="info"
              v-if="item.issued && tenant !== 'sanjivani' && tenant !== 'vvp' && tenant !== 'wws'" small
              :loading="show_cert_loader" @click="showCert2(item)">Get Bonafide (download pdf)</v-btn> -->
          </template>
          <!-- <template v-slot:item.generate="{ item }">
            <v-btn class="mt-2 mb-2" rounded color="warning" :loading="gen_cert_loader" small
              @click="openPrincipalDialog(item)">Generate Bonafide</v-btn>
          </template> -->
          <template v-slot:item.generate="{ item }"> <v-btn class="mt-2 mb-2" rounded color="warning" :loading="gen_cert_loader"small
            @click=" tenant == 'vvp' ? openProgressDialog(item) : openPrincipalDialog(item)">
                Generate Bonafide
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template>
      <!-- <div class="text-center" v-if="cert_data != null">
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card flat>
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Bonafide Certificate </strong>
              </v-toolbar-title>
            </v-toolbar>
            <center>
              <v-btn class="button no-display" @click="print"> Print </v-btn>
              <v-btn class="button no-display" rounded @click="dialog = false">
                Close
              </v-btn>
            </center>

            <div id="printMe">
              <br /><br />
              <v-card class="cert-box v-card" flat>
                <v-row justify="center">
                  <v-col cols="12" sm="2" md="2" align="right">
                    <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                  </v-col>
                  <v-col cols="12" sm="8" md="8">
                    <center>
                      <br />
                      <strong>
                        <span v-if="org_basic_data.trust_name">{{
                          org_basic_data.trust_name
                        }}</span></strong><br />
                      <strong><span v-if="org_basic_data.trust_name">{{
                        org_basic_data.school_name
                          }}</span></strong><br />
                      <span v-if="org_basic_data.address">{{
                        org_basic_data.address
                      }}</span><br />
                      <span v-if="org_basic_data.phone">Phone : {{ org_basic_data.phone }}</span>
                      <br />
                      <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span>
                      <br />
                      <span v-if="org_basic_data.website">Website : {{ org_basic_data.website }}</span>
                    </center>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" align="left">
                    <br />
                    <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                  </v-col>
                </v-row>
                <v-row justify="center" class="ml-2">
                  <v-col cols="12" sm="4" md="4">
                    <strong>Affiliation No: 1130534</strong><br />
                    <strong>Sr. No. {{ cert_data.cert_no }}</strong>
                  </v-col>
                  <v-col cols="12" sm="5" md="5"></v-col>
                  <v-col align="right" cols="12" sm="3" md="3"><span style="margin-right: 15%">Date: {{
                    cert_data.cert_date }}</span></v-col>
                </v-row>
                <center>
                  <strong>
                    <span style="font-size: 1.3em; text-transform: uppercase">To whomsoever it may concern</span>
                  </strong>
                </center>
                <br />
                <v-row class="ml-2">
                  <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
                    <i>
                      This is to verify that Miss / Master
                      <strong><u>{{ cert_data.stud_name }}</u></strong></i><br />
                    <br />
                    is / was the student of Grade
                    <strong><u>{{ cert_data.std }}</u></strong>
                    Div.
                    <strong><u>{{ cert_data.div }}</u></strong>
                    for the academic year
                    <strong><u>{{ cert_data.ay }}</u></strong><br />
                    <br />
                    His / Her Date of birth according to our record is
                    <strong><u>{{ cert_data.dob }}</u></strong><br />
                    <br />
                    His / Her address is
                    <strong><u>{{ cert_data.address }}</u></strong>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" style="font-size: 1.3em">
                    <img :src="awspath + cert_data.photo" width="75%" alt="logo" />
                  </v-col>
                </v-row>
                <v-row class="ml-2">
                  <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
                    He / She bears a good moral character. This certificate is
                    issued for Ration card / Bank account / Aadhar Card / Caste
                    Certificate / VISA / Passport.
                  </v-col>
                </v-row>
                <br /><br /><br /><br /><br /><br />
                <span class="bottomright" style="font-size: 1.3em"><strong>PRINCIPAL</strong></span>
              </v-card>
            </div>
          </v-card>
        </v-dialog>
      </div> -->
    </template>

    <v-dialog v-model="show_principle_list" max-width="500">
      <v-card>
        <v-card-title>
          Select Principal
        </v-card-title>

        <v-card-text>
          <v-select v-model="principal" :items="principal_list" item-text="name" item-value="id" label="Principal"
            outlined dense />
        </v-card-text>
        <v-card-actions>
          
          <v-spacer />
          

          <v-btn text @click="show_principle_list = false">
            Cancel
          </v-btn>

          <v-btn color="primary" @click="generateCertificate">
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_remark" max-width="500" v-if="tenant=='savpm'">
      <v-card>
                <v-col cols="11" class="ml-5">
                    <p><b>Remark</b></p>
                    <v-text-field  outlined dense type="text" v-model="remark" label="Enter Remark"></v-text-field>
                </v-col>
                    
       <v-card-actions>
          
          <v-spacer />
          

          <v-btn text @click="show_remark = false">
            Cancel
          </v-btn>

          <v-btn color="primary" @click="generateCert">
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="show_progress" max-width="500" >
      <v-card>
                <v-col cols="11" class="ml-5">
                    <p><b>Purpose</b></p>
                    <v-text-field  outlined dense type="text" v-model="remark" label="Enter Purpose"></v-text-field>
                </v-col>
                <v-col cols="11" class="ml-5">
                    <p><b>Progress</b></p>
                    <v-text-field  outlined dense type="text" v-model="progress" label="Enter Progress"></v-text-field>
                </v-col>
                <v-col cols="11" class="ml-5">
                    <p><b>Behavior</b></p>
                    <v-text-field  outlined dense type="text" v-model="behavior" label="Enter Behavior"></v-text-field>
                </v-col>
              <v-card-actions>
          
          <v-spacer />
          

          <v-btn text @click="show_progress = false">
            Cancel
          </v-btn>

          <v-btn color="primary" @click="generateCert">
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="show_progress" max-width="600px">
  <v-card>

    <v-card-title>
      Purpose
    </v-card-title>

    <v-card-text>

      <!-- Purpose -->
      <v-text-field
        v-model="purpose"
        label="Purpose"
        placeholder="Enter Purpose"
      ></v-text-field>

      <!-- Progress -->
      <v-text-field
        v-model="progress"
        label="Progress"
        placeholder="Enter Progress"
      ></v-text-field>

      <!-- Behavior -->
      <v-text-field
        v-model="behavior"
        label="Behavior"
        placeholder="Enter Behavior"
      ></v-text-field>
       <v-col cols="12" sm="5" md="5">
          <p class="pl-2 mb-3"><b>Attendance</b>&nbsp;</p>
              <v-autocomplete color="#0F2027" dense rounded v-model="attendence"
                    :items="attendence_status" item-text="name" item-value="id" outlined />
              </v-col>

      <!-- Convert to Marathi Checkbox -->
      <v-checkbox
        v-model="convertToMarathi"
        label="Convert to Marathi"
        class="mt-2"
        @change="convertPurposeProgressBehavior"
      ></v-checkbox>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        text
        @click="show_progress = false"
      >
        CANCEL
      </v-btn>

      <v-btn
        color="primary"
        @click="generateCert"
      >
        GENERATE
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      fetch_loader: false,
      gen_cert_loader: false,
      show_cert_loader: false,
      search: "",
      dialog: false,
      awspath: "",
      org_id: null,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      data_list: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      cert_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      overlay: false,
      org_basic_data: [],
      principal_list:[],
      show_principle_list: false,
      principal: null,
      remark: null,
      progress: null,
      behavior: null,
      show_progress: false,
      show_remark:false,
      convertToMarathi: false,
      purpose:null,
      attendence: null,
      attendence_marathi: "",
      attendence_status: [
            { id: "Regular", name: "Regular" },
            { id: "Irregular", name: "Irregular"}
        ],
      selectedItem: null,
      headers: [
        {
          text: "Sr. No.",
          sortable: true,
          value: "srno",
        },
        {
          text: "Student Name",
          align: "center",
          sortable: true,
          value: "name",
        },
        {
          text: "PRNo",
          align: "center",
          sortable: true,
          value: "prno",
        },
        {
          text: "RollNo",
          align: "center",
          sortable: true,
          value: "rollno",
        },
        {
          text: "Issued",
          align: "center",
          sortable: true,
          value: "issued",
        },
        {
          text: "Issued Dates",
          align: "center",
          sortable: false,
          value: "issued_dates",
        },
        {
          text: "Get Issued Bonafide",
          align: "center",
          sortable: false,
          value: "get",
        },
        {
          text: "Generate Bonafide",
          align: "center",
          sortable: false,
          value: "generate",
        },
      ],
    };
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    showCert1(item) {
      if (this.tenant === 'sanjivani') {
        this.cert_data = item.cert_data;
        this.$router.push({
          name: 'get-bonafied-certificate-sanjivani-print',
          target: 'blank',
          params: {
            cert_data: this.cert_data,
            org_basic_data: this.org_basic_data,
          },
        });
      }
      else if (this.tenant === 'vvp') {
        this.cert_data = item.cert_data;
        this.$router.push({
          name: 'get-bonafide-certificate-vvp-print',
          target: 'blank',
          params: {
            cert_data: this.cert_data,
            org_basic_data: this.org_basic_data,
          },
        });
      } else {
        this.cert_data = item.cert_data;
        this.$router.push({
          name: "get-certificate-bonafied1",
          target: "blank",
          params: {
            cert_data: this.cert_data,
            org_basic_data: this.org_basic_data,
          },
        });
      }
    },
    showCert2(item) {
     if (this.tenant === 'desschool' || this.tenant == 'mkd') {
        const routeData = this.$router.resolve({
            name: 'bonafide-certificate-des',
            query: {
             ldid : item.ldid,
             prno : item.prno
            }
          });
          window.open(routeData.href, '_blank');
      }else{
        this.cert_data = item.cert_data;
        this.$router.push({
          name: "get-certificate-bonafied2",
          target: "blank",
          params: {
            cert_data: this.cert_data,
            org_basic_data: this.org_basic_data,
          },
        });
      }
    },
    showCert(item) {
      if (this.tenant === 'sanjivani') {
        if (this.org_id == '5' || this.org_id == '6') {
          const routeData = this.$router.resolve({
            name: 'get-bonafied-certificate-sjcv',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data),
              rollno: item.rollno,
            }
          });
          window.open(routeData.href, '_blank');
        } else if (this.org_id == '4') {
          const routeData = this.$router.resolve({
            name: 'get-bonafide-certificate-ssjc',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data),
            }
          });
          window.open(routeData.href, '_blank');
        }
        else {
          const routeData = this.$router.resolve({
            name: 'get-bonafied-certificate-sanjivani',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data),
              prno: item.prno,
            }
          });
          window.open(routeData.href, '_blank');
        }
      }
      else if (this.tenant === 'vvp') {
        if(this.org_id=="2"){
          const routeData = this.$router.resolve({
            name: 'bonafide-certificate-des',
            query: {
             ldid : item.ldid,
             prno : item.prno
            }
          });
          window.open(routeData.href, '_blank');
        }else{
            const routeData = this.$router.resolve({
            name: 'get-bonafide-certificate-vvp',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data)
            }
          });
          window.open(routeData.href, '_blank');
        }
        
      }
      else if (this.tenant === 'wws') {
         const routeData = this.$router.resolve({
            name: 'get-bonafide-certificate-wws',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data),
              prno: item.prno,
              reason: item.reason,
            }
          });
          window.open(routeData.href, '_blank');
      }
      else if (this.tenant === 'sbpps') {
        const routeData = this.$router.resolve({
            name: 'get-certificate-bonafied',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data)
            }
          });
          window.open(routeData.href, '_blank');
      }
      else if (this.tenant === 'desschool' || this.tenant == 'mkd' || this.tenant == 'savpm') {
        const routeData = this.$router.resolve({
            name: 'bonafide-certificate-des',
            query: {
             ldid : item.ldid,
             prno : item.prno
            }
          });
          window.open(routeData.href, '_blank');
      }
      else {
        const routeData = this.$router.resolve({
            name: 'get-certificate-bonafied',
            query: {
              cert_data: JSON.stringify(item.cert_data),
              org_basic_data: JSON.stringify(this.org_basic_data)
            }
          });
          window.open(routeData.href, '_blank');
      }
    },
    genCert(item) {  
      this.gen_cert_loader = true;
      axios
        .post("/certificate/genCert", item)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.cert_data = res.data.cert_data;
            this.remark = null;
            this.progress = null;
            this.behavior = null;
            let index = this.data_list.indexOf(item);
            this.data_list[index].cert_data = this.cert_data;
            this.data_list[index].issued = true;
            if (this.tenant === 'vvp') {

              if(this.org_id=="2"){
                const routeData = this.$router.resolve({
                name: 'bonafide-certificate-des',
                query: {
                  ldid : item.ldid,
                  prno : item.prno
            }
              });
              window.open(routeData.href, '_blank');

              }else{
                const routeData = this.$router.resolve({
                name: 'get-bonafide-certificate-vvp',
                query: {
                  cert_data: JSON.stringify(item.cert_data),
                  org_basic_data: JSON.stringify(this.org_basic_data)
                }
                });
                window.open(routeData.href, '_blank');

              }              
              // window.open(routeData.href, '_blank');
              console.log(this.data_list[index]);
            }
            else if (this.tenant === 'sanjivani') {
              if (this.org_id == '5' || this.org_id == '6') {
                const routeData = this.$router.resolve({
                  name: 'get-bonafied-certificate-sjcv',
                  query: {
                    cert_data: JSON.stringify(item.cert_data),
                    org_basic_data: JSON.stringify(this.org_basic_data),
                    rollno: item.rollno,
                  }
                });
                window.open(routeData.href, '_blank');
              } else if (this.org_id == '4') {
                const routeData = this.$router.resolve({
                  name: 'get-bonafide-certificate-ssjc',
                  query: {
                    cert_data: JSON.stringify(item.cert_data),
                    org_basic_data: JSON.stringify(this.org_basic_data),
                  }
                });
                window.open(routeData.href, '_blank');
              }
              else {
                const routeData = this.$router.resolve({
                  name: 'get-bonafied-certificate-sanjivani',
                  query: {
                    cert_data: JSON.stringify(item.cert_data),
                    org_basic_data: JSON.stringify(this.org_basic_data),
                    prno: item.prno,
                  }
                });
                window.open(routeData.href, '_blank');
                console.log(this.data_list[index]);
              }
            }
            else if (this.tenant === 'wws') {
             const routeData = this.$router.resolve({
                name: 'get-bonafide-certificate-wws',
                query: {
                  cert_data: JSON.stringify(item.cert_data),
                  org_basic_data: JSON.stringify(this.org_basic_data),
                  prno: item.prno,
                  reason: item.reason,
                }
              });
              window.open(routeData.href, '_blank');
              console.log(this.data_list[index]);
            }
            this.dialog = true;
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.onerror(error);
          this.gen_cert_loader = false;
        })
        .finally(() => {
          this.gen_cert_loader = false;
        });
    },
//    async convertPurposeProgressBehavior() {
//   if (!this.convertToMarathi) {
//     return;
//   }

//   try {
//     if (this.purpose && this.purpose.trim()) {
//       this.purpose = await this.translateToMarathi(this.purpose);
//     }

//     if (this.progress && this.progress.trim()) {
//       this.progress = await this.translateToMarathi(this.progress);
//     }

//     if (this.behavior && this.behavior.trim()) {
//       this.behavior = await this.translateToMarathi(this.behavior);
//     }

//     if (this.attendence) {
//       const selectedAttendance = this.attendence_status.find(
//         item => String(item.id) === String(this.attendence)
//       );

//       if (selectedAttendance) {
//         this.attendence = this.convertAttendanceToMarathi(
//           selectedAttendance.name
//         );
//       }
//     }

//   } catch (error) {
//     console.error("Marathi conversion failed:", error);
//   }
// },
    

async convertPurposeProgressBehavior() {
  if (!this.convertToMarathi) {
    this.attendence_status = [
      { id: "Regular", name: "Regular" },
      { id: "Irregular", name: "Irregular" }
    ];
    return;
  }

  try {
    if (this.purpose && this.purpose.trim()) {
      this.purpose = await this.translateToMarathi(this.purpose);
    }

    if (this.progress && this.progress.trim()) {
      this.progress = await this.translateToMarathi(this.progress);
    }

    if (this.behavior && this.behavior.trim()) {
      this.behavior = await this.translateToMarathi(this.behavior);
    }

    // Get currently selected attendance
    const selectedAttendance = this.attendence_status.find(
      item => item.id === this.attendence
    );

    if (selectedAttendance) {

      const attendanceMap = {
        "Regular": "नियमित",
        "Irregular": "अनियमित"
      };

      const marathiAttendance =
        attendanceMap[selectedAttendance.name] ||
        selectedAttendance.name;

      // Change the selected value itself
      this.attendence = marathiAttendance;

      // Change dropdown items so autocomplete does not become blank
      this.attendence_status = [
        {
          id: "नियमित",
          name: "नियमित"
        },
        {
          id: "अनियमित",
          name: "अनियमित"
        }
      ];
    }

  } catch (error) {
    console.error("Marathi conversion failed:", error);
  }
},

    async translateToMarathi(text) {
  if (!text || !text.trim()) {
    return text;
  }

  try {
    const url =
      "https://translate.googleapis.com/translate_a/single" +
      "?client=gtx" +
      "&sl=en" +
      "&tl=mr" +
      "&dt=t" +
      "&q=" + encodeURIComponent(text);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Translation request failed");
    }

    const data = await response.json();

    let translatedText = "";

    if (data && data[0]) {
      data[0].forEach(item => {
        if (item && item[0]) {
          translatedText += item[0];
        }
      });
    }

    return translatedText || text;

  } catch (error) {
    console.error("English to Marathi translation error:", error);
    return text;
  }
},
convertAttendanceToMarathi(value) {
  if (!value) {
    return "";
  }

  const selectedAttendance = this.attendence_status.find(
    item => item.id === value
  );

  if (!selectedAttendance) {
    return "";
  }

  const attendanceName = selectedAttendance.name;

  const attendanceMap = {
    "Regular": "नियमित",
    "Irregular": "अनियमित"
  };

  return attendanceMap[attendanceName] || attendanceName;
},
    getbonafiedcertificates() {
      let div = this.div.div_off_id;
      if (this.div.div_off_id) {
        div = this.div.div_off_id;
      } else {
        div = this.div;
      }

      const formdata = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        div_off_id: div,
      };
      this.fetch_loader = true;
      axios
        .post("/certificate/getbonafiedcertificates", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.data_list = res.data.data_list;
            this.org_basic_data = res.data.org_basic_data;
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.onerror(error);
          this.fetch_loader = false;
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    openPrincipalDialog(item) {
      this.selectedItem = item;

        if (this.principal_list && this.principal_list.length > 1) {
            this.principal = null;
            this.show_principle_list = true;
        } else {
            localStorage.removeItem("principle_id");
            if(this.tenant=='savpm' ){
              this.remark=null;
              this.show_remark=true;
            }else{
              this.genCert(item);
            }
            
        }
    },
    openProgressDialog(item) {
      this.selectedItem = item;

        if(this.tenant == 'vvp'){
          if(this.org_id == '2'){
            console.log("inside.......")
            this.purpose = null
            this.progress = null;
            this.behavior = null;
            this.show_progress = true;
          }else{
            this.genCert(item);
          }
        }else{
          this.genCert(item);
        }

    },

    generateCertificate() {
        if (!this.principal) {
            this.showSnackbar("error", "Please select Principal");
            return;
        }

        localStorage.setItem("principle_id", String(this.principal));
        this.show_principle_list = false;
        this.selectedItem.remark = this.remark;
        console.log("this.selectedItem==========="+this.selectedItem);
        
        this.genCert(this.selectedItem);
    },
    generateCert() {
        this.show_remark = false;
        this.show_progress = false;
        this.selectedItem.purpose = this.purpose
        this.selectedItem.progress = this.progress
        this.selectedItem.behavior = this.behavior
        this.selectedItem.remark = this.remark
        this.selectedItem.attendence = this.attendence
        this.genCert(this.selectedItem);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => { });
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.tenant = localStorage.getItem("EPS-tenant");
    this.org_id = localStorage.getItem("EPS-org-id");
    this.onload();

      axios
        .post("Certificate/getPrincipalList")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.principal_list = res.data.principal_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => { });
  },
};
</script>
<style scoped>
.cert-box {
  border: 2px solid #0f2027 !important;
  margin-top: 5%;
  margin-right: 10%;
  margin-left: 10%;
  padding: 10px;
}

.bottomright {
  position: absolute;
  bottom: 8px;
  right: 16px;
  font-size: 18px;
}
@media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  img {
    width: 100% !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .v-card {
    font-size: 1.5em !important;
  }

  @page {
    size: A4 landscape;
    size: 25.5in 20.5in;
  }

  * {
    overflow: hidden !important;
  }
}
</style>
